module.exports = __webpack_public_path__ + "img/git-logo.e6dadc67.png";